// @ts-strict-ignore
import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPayoutsTransferWallets } from 'services/UnifiedPayoutsService'

export interface TransferWalletsParams {
  walletId: string
  currencyCode: string
  walletType: string
  customerReference: string
}

export const useGetPayoutsTransferWalletsQuery = (
  { walletId, currencyCode, walletType, customerReference }: TransferWalletsParams,
  enabled?: boolean
) => {
  return useQuery({
    queryKey: reactQueryKeys.transferWallets({
      ...(customerReference && { customerReference }),
      ...(currencyCode && { currencyCode }),
      ...(walletType && { walletType }),
      ...(walletId && { walletId }),
    }),
    queryFn: () =>
      getPayoutsTransferWallets({ walletId, currencyCode, walletType, customerReference }),
    enabled,
  })
}
